import { render } from "./User.vue?vue&type=template&id=07a66d82&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=07a66d82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07a66d82"

export default script